import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { UserPlus, Briefcase, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

const PortalRegisterPage = () => {
  const [companyName, setCompanyName] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [roleTitle, setRoleTitle] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API}/portal/auth/register`, {
        company_name: companyName,
        full_name: fullName,
        email,
        phone: phone || null,
        role_title: roleTitle || null,
        password,
      });
      localStorage.setItem("portalToken", response.data.token);
      toast.success("Portal account created");
      navigate("/portal");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Portal signup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="w-full max-w-lg border-primary/20">
        <CardHeader>
          <CardTitle className="flex items-center gap-3 text-2xl"><Briefcase className="h-6 w-6 text-primary" /> Worker Portal Signup</CardTitle>
          <CardDescription>Create a subcontractor portal account to manage bookings and availability.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2"><Label>Company Name</Label><Input value={companyName} onChange={(e) => setCompanyName(e.target.value)} required className="bg-muted/50" /></div>
            <div className="space-y-2"><Label>Full Name</Label><Input value={fullName} onChange={(e) => setFullName(e.target.value)} required className="bg-muted/50" /></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="space-y-2"><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="bg-muted/50" /></div>
              <div className="space-y-2"><Label>Phone</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} className="bg-muted/50" /></div>
            </div>
            <div className="space-y-2"><Label>Role / Title</Label><Input value={roleTitle} onChange={(e) => setRoleTitle(e.target.value)} placeholder="Owner / Manager" className="bg-muted/50" /></div>
            <div className="space-y-2"><Label>Password</Label><Input type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} required className="bg-muted/50" /></div>
            <Button type="submit" disabled={loading} className="w-full bg-primary hover:bg-primary/90">
              {loading ? "Creating account..." : <span className="flex items-center gap-2"><UserPlus size={16} /> Create portal account</span>}
            </Button>
          </form>
          <div className="mt-6 border-t border-border pt-4 text-sm text-muted-foreground text-center">
            Already have a portal account?{" "}
            <Link to="/portal/login" className="text-primary hover:underline font-medium inline-flex items-center gap-1">
              <ArrowLeft size={14} /> Back to sign in
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PortalRegisterPage;
